module.exports = __webpack_public_path__ + "static/pricing_monthly-5eb6638542114e7c79f02e4c3ae16f6f.png";